import React, { useCallback, useState } from "react";
import OltSelect from "../../../../components/OltSelect";
import { Box, Button, FormControl, InputLabel, MenuItem, Select, Step, StepLabel, Stepper, TextField } from "@mui/material";
import { useFormError } from "../../../../components/Datatable/FormErrorProvider";
import api from "../../../../services/api";
import { useNotify } from "../../../../components/Datatable/NotifyProvider";
import FreeOnuSelect from "../FreeOnuSelectDetail";
import { SearchRounded } from "@mui/icons-material";
import { grey } from "@mui/material/colors";
import LineSrvSelect from "../../../../components/LineSrvSelect";
import CustomTextField from "../../../../components/CustomTextField";
import ProvisioningProgressModal from "../../../../components/ProvisioningProgressModal";


function genTaskId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID().replace(/-/g, "").slice(0, 8);
  return Math.random().toString(16).slice(2, 10);
}


export default function ProvDetail() {
  const error = useFormError()
  const [searchOnu, setSearchOnu] = useState(false)
  const [taskId, setTaskId] = useState(null)
  const [modalOpen, setModalOpen] = useState(false)
  const [result, setResult] = useState(null)


  const [waitOlt, setWaitOlt] = useState(true)


  const fetchProv = () => {
    error.setErrors([])
    const tid = genTaskId()
    setTaskId(tid)
    setResult(null)
    setModalOpen(true)
    const snap = { ...state }
    api.post(`provisioning/olt/prov/detail/?task_id=${tid}`, { ...state, roteada: state.roteada == 2 })
      .then(res => {
        if (res.data.error) {
          setResult({ ok: false, message: res.data.error })
          return
        }
        if (res.data.errors) {
          setModalOpen(false)
          error.setErrors(res.data.errors)
          return
        }

        setResult({
          ok: true,
          message: "ONU provisionada com sucesso",
          info: [
            { label: "SN", value: snap.sn },
            { label: "Placa", value: snap.board },
            { label: "Porta", value: snap.port },
            { label: "VLAN", value: snap.vlan },
            { label: "Gemport", value: snap.gemport },
            { label: "Modo", value: snap.roteada == 2 ? "Roteada" : "Bridge" },
            { label: "Descrição", value: snap.description },
          ],
        })
        setState({
          sn: "",
          vlan: "",
          line: null,
          srv: null,
          description: "",
          olt: null,
          board: "",
          port: "",
          gemport: ""
        })
      }

      )
      .catch(e => {
        setResult({ ok: false, message: "Falha: " + (e?.message || e) })
      })
  }
  const [state, setState] = useState({
    sn: "",
    vlan: "",
    line: null,
    srv: null,
    description: "",
    roteada: 1,
    olt: null,
    board: "",
    port: "",
    gemport: ""
  })
  const notify = useNotify()


  const handleState = useCallback((event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  }, [state])


  return (
    <Box display={"flex"} flexDirection={"column"} gap={1}

      sx={{
        width: { xs: "auto", sm: "auto", md: 400 }
      }}
    >
      <OltSelect

        size="small"
        value={state.olt}
        handler={(e) => { setState({ ...state, olt: e }); setWaitOlt(true) }}
        admin={false}
      />
      <Box display={"flex"} gap={1}
      
        sx={{
          flexDirection: {xs: "column", sm: "row"}
        }}
      >

        <CustomTextField
          size="small"
          error={error.verify('board')}
          helperText={error.msgError('board')}
          label='Placa'
          value={state.board}
          name={'board'}
          onChange={handleState}
          sx={{ flexGrow: 1 }}
          type="number"
        />
        <CustomTextField
          size="small"
          error={error.verify('port')}
          helperText={error.msgError('port')}
          label='Porta'
          value={state.port}
          name={'port'}
          onChange={handleState}
          type="number"
          sx={{ flexGrow: 1 }}
        />

        <Button
          size="small"
          sx={{
            height: 40,
            flexGrow: 0
          }}
          variant="contained"
          color="primary"
          onClick={() => { setSearchOnu(true); setWaitOlt(false) }}
          disabled={state.olt === "" || state.board === "" || state.port === ""}
        >
          <SearchRounded />
        </Button>
      </Box>

      <FreeOnuSelect

        disabled={waitOlt}
        olt={state.olt}
        board={state.board}
        port={state.port}
        submit={searchOnu}
        handlerSn={(sn) => setState(prev => ({ ...prev, sn }))}
        handlerLine={(line) => setState(prev => ({ ...prev, line }))}
        handlerSrv={(srv) => setState(prev => ({ ...prev, srv }))}
        handlerSubmit={() => setSearchOnu(false)}

      />
      <CustomTextField
        size="small"

        error={error.verify('vlan')}
        helperText={error.msgError('vlan')}
        label='Vlan'
        value={state.vlan}
        name={'vlan'}
        disabled={waitOlt}
        onChange={handleState}
        type="number"
      />
      <CustomTextField
        disabled={waitOlt}

        size="small"

        error={error.verify('gemport')}
        helperText={error.msgError('gemport')}
        label='Gemport'
        value={state.gemport}
        name={'gemport'}

        onChange={handleState}
        type="number"
      />
      <FormControl size="small">
        <InputLabel id="mode-prov-select-label">Modo</InputLabel>
        <Select
          disabled={waitOlt}
          inputProps={{ size: "small" }}
          labelId="mode-prov-select-label"
          id="mode-prov-select"
          value={state?.roteada}
          label="Modo"
          onChange={e => setState({ ...state, roteada: e.target.value })}
        >
          <MenuItem value={1}>Brigde</MenuItem>
          <MenuItem value={2}>Roteada</MenuItem>

        </Select>
      </FormControl>



      <CustomTextField
        disabled={waitOlt}
        size="small"
        error={error.verify('description')}
        helperText={error.msgError('description')}
        label='Descrição'
        value={state.description}
        name={'description'}
        onChange={handleState}
        type="text"
      />


      <Button variant="contained" disabled={waitOlt}

        onClick={fetchProv}>{"Provisionar"}</Button>

      <ProvisioningProgressModal
        open={modalOpen}
        taskId={taskId}
        mode="user"
        streamPath="/provisioning/stream"
        result={result}
        onClose={() => { setModalOpen(false); setResult(null) }}
      />
    </Box >
  )
}